// Web Learning Hub for the School profile — reuses the Student+Parent implementation.
// The Header/Footer auto-detect the profile from `/school/*` path so nav & branding update
// automatically; the underlying content (dashboard, tools, quiz demo, progress) is identical.
import StudentLearningHub from '../student/StudentLearningHub';

export default StudentLearningHub;
